import { notification } from "antd";
import { IBrandSampleSet } from "../../../Models/IBrandSampleSet";
import { IBrand } from "../../../Models/Models";
import {
    BrandActionType,
    GET_ALL_BRANDS_FAILURE,
    GET_ALL_BRANDS_SUCCESS,
    GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_FAILURE,
    GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_SUCCESS,
    GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_FAILURE,
    GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_SUCCESS,
    SET_LOADING_BRANDS,
    SET_LOADING_BRAND_SAMPLE_SET_LOCATIONS,
    RESET_BRAND_SAMPLE_SET,
    ICorrelatedBaseAction,
} from "../Types/BrandActionTypes";

export interface IBrandsReducerState {
  brands: IBrand[];
  loadingBrands: boolean;
  sampleSet: IBrandSampleSet[];
  sampleSetCorrelationId: number;
  loadingSampleSet: boolean;
}

export const brandReducerState: IBrandsReducerState = {
    brands: [],
    loadingBrands: false,
    sampleSet: [],
    loadingSampleSet: false,
    sampleSetCorrelationId: -1,
};

export const brandsReducer = (
    state: IBrandsReducerState = { ...brandReducerState },
    action: BrandActionType
): IBrandsReducerState => {
    switch (action.type) {
    /** misc */
        case SET_LOADING_BRANDS: {
            return {
                ...state,
                loadingBrands: action.data as boolean,
            };
        }
        case SET_LOADING_BRAND_SAMPLE_SET_LOCATIONS: {
            return {
                ...state,
                loadingBrands: action.data as boolean,
            };
        }
        /** success */
        case GET_ALL_BRANDS_SUCCESS: {
            return {
                ...state,
                brands: action.data as IBrand[],
            };
        }
        case GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_SUCCESS:
        case GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_SUCCESS: {
            const a = action as ICorrelatedBaseAction<IBrandSampleSet[]>;
            return state.sampleSetCorrelationId > a.correlationId ? state : {
                ...state,
                sampleSet: a.data,
                sampleSetCorrelationId: a.correlationId
            };
        }
        /** failure */
        case GET_ALL_BRANDS_FAILURE: {
            notification.error({
                message: "Error getting Brands",
                description: action.data,
            });
            return {
                ...state,
            };
        }
        case GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_FAILURE:
        case GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_FAILURE: {
            const a = action as ICorrelatedBaseAction<string>;
            if (a.correlationId > state.sampleSetCorrelationId) {
                notification.error({
                    message: "Error getting Sample Set locations",
                    description: action.data,
                });
                return {
                    ...state,
                    sampleSetCorrelationId: a.correlationId,
                    sampleSet: [],
                };
            } else {
                return state;
            };
        }
        case RESET_BRAND_SAMPLE_SET: {
            return {
                ...state,
                sampleSetCorrelationId: action.data as number,
                sampleSet: [],
                loadingSampleSet: false,
            };
        }
        default: {
            return state;
        }
    }
};
